import { createSelector } from '@reduxjs/toolkit';

import { selectSpecialtyTypes } from 'shared/selectors/jsonQuery';

import { selectBusinessAppointmentsGroups } from './selectBusinessAppointmentsGroups';

const DEFAULT_LABEL = 'Категория';

export const selectBusinessAppointmentsLabel = createSelector(
  [selectBusinessAppointmentsGroups, selectSpecialtyTypes],
  (groups, selectedIds) => {
    if (!selectedIds || selectedIds.length === 0) {
      return DEFAULT_LABEL;
    }

    const allItems = groups.flatMap(g => g.items);
    const labels = selectedIds.map(id => allItems.find(i => i.id === id)?.name).filter(Boolean) as string[];

    if (labels.length === 0) {
      return DEFAULT_LABEL;
    }

    return labels.join(', ');
  },
);
